import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiSeasons: ApiType = {
  get: {
    search: ({ query, vars }) =>
      api.get(stringParse('/api/seasons?search={0}&active=true', vars), query),
    list: ({ vars }) => api.get(stringParse('/api/seasons?active=true', vars)),
  },
  put: {},
  post: {},
  delete: {},
};
